import { ApiService } from "@/lib/api.service";
import {
  CreateContactMessageRequest,
  ContactMessageResponse,
} from "./contact.model";

const CONTACT_BASE_URL = `${process.env.NEXT_PUBLIC_API_URL_V2}/contact`;

class ContactServiceClass extends ApiService {
  async submitContactMessage(
    data: CreateContactMessageRequest,
  ): Promise<ContactMessageResponse> {
    const response = await this.post(CONTACT_BASE_URL, data);
    return response.data;
  }
}

export const contactService = new ContactServiceClass();
